import { useRoute, type RouteProp } from '@react-navigation/native';
import type { SearchStackParamList } from '../../../Navigator';

export const useSearchResultRoute = <T extends keyof SearchStackParamList>() =>
  useRoute<RouteProp<SearchStackParamList, T>>();